import { CertGenParams } from '@yandex-int/k-common';

import { CertificatesParamsModalData } from 'common.components/certificates-params-modal/certificates-params-modal';

export enum CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE {
    FULL_NAME = 'fullName',
    LOCALITY = 'locality',
    SCHOOL = 'school',
    NEED_PAPER_VARIANT = 'need_paper_variant',
    RESIDENCE_ADDRESS = 'residence_address',
    SNLS = 'snls',
    DATE_OF_BIRTH = 'date_of_birth',
    GENDER = 'gender',
    CITIZENSHIP_RU = 'citizenship_ru',
    CITIZENSHIP_OTHERS = 'citizenship_others',
    HAS_HIGHER_EDUCATION = 'has_higher_education',
}

export enum CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE {
    TEXT = 'text',
    RADIO = 'radio',
    CHECKBOX = 'checkbox',
    DATE = 'date',
}

export interface CertGenParamsWithDate extends CertGenParams {
    issue_date?: string;
}

export interface CertGenExpandedParams extends CertGenParams {
    need_paper_variant: string;
    residence_address: string | null;
    snls: string;
    date_of_birth: string;
    gender: string;
    citizenship_ru: string;
    citizenship_others: string | null;
    has_higher_education: string;
    serial_number?: string;
    issue_date?: string;
    slug?: string;
}

export interface CertificatesExpandedParamsModalData extends CertificatesParamsModalData {
    need_paper_variant: string;
    residence_address: string | null;
    snls: string;
    date_of_birth: string;
    gender: string;
    citizenship_ru: string;
    citizenship_others: string | null;
    has_higher_education: string;
}

export interface CertificatesExpandedParamsModalFormFieldConfig {
    infoType: CERTIFICATES_EXPANDED_FORM_FIELD_INFO_TYPE;
    required?: boolean;
}

export interface CertificatesExpandedParamsModalTextFormFieldConfig
    extends CertificatesExpandedParamsModalFormFieldConfig {
    inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.TEXT;
}

export interface CertificatesExpandedParamsModalRadioFormFieldConfig
    extends CertificatesExpandedParamsModalFormFieldConfig {
    inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.RADIO;
    options: {
        choices: string[];
    };
}

export interface CertificatesExpandedParamsModalDateFormFieldConfig
    extends CertificatesExpandedParamsModalFormFieldConfig {
    inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.DATE;
}

export interface CertificatesExpandedParamsModalCheckboxFormFieldConfig
    extends CertificatesExpandedParamsModalFormFieldConfig {
    inputType: CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.CHECKBOX;
}

export type CertificatesExpandedParamsModalFieldConfig =
    | CertificatesExpandedParamsModalTextFormFieldConfig
    | CertificatesExpandedParamsModalRadioFormFieldConfig
    | CertificatesExpandedParamsModalDateFormFieldConfig
    | CertificatesExpandedParamsModalCheckboxFormFieldConfig;
